const rankings = [
  { rank: 1, title: '《庆余年2》', heat: '98.6万', trend: 'up', desc: '范闲归来引爆全网话题' },
  { rank: 2, title: '《繁花》', heat: '92.3万', trend: 'up', desc: '王家卫首部电视剧口碑发酵' },
  { rank: 3, title: '《唐朝诡事录2》', heat: '87.5万', trend: 'up', desc: '奇幻探案题材持续升温' },
  { rank: 4, title: '《长相思2》', heat: '82.1万', trend: 'flat', desc: '暑期档仙侠大作热度稳定' },
  { rank: 5, title: '《孤舟》', heat: '76.8万', trend: 'up', desc: '谍战新剧口碑持续走高' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-500/10 border border-accent-500/20 mb-4">
            <i className="ri-trophy-line text-accent-500 text-sm"></i>
            <span className="text-accent-400 text-xs font-medium">热度排行</span>
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">全网热播剧排行</h2>
          <p className="text-foreground-500 text-sm mt-3 max-w-xl mx-auto">
            基于全网讨论热度与播放数据实时生成，每日自动更新
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          {rankings.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-4 p-4 border-b border-background-200/60 last:border-0 hover:bg-background-50 transition-colors cursor-pointer group"
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-lg font-bold text-sm flex-shrink-0 ${
                item.rank === 1
                  ? 'bg-primary-500 text-background-950'
                  : item.rank === 2
                  ? 'bg-primary-500/80 text-background-950'
                  : item.rank === 3
                  ? 'bg-primary-500/60 text-background-950'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-foreground-800 font-heading font-bold text-sm group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h4>
                <p className="text-foreground-500 text-xs truncate">{item.desc}</p>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <i className={`text-xs ${
                  item.trend === 'up'
                    ? 'ri-arrow-up-line text-green-500'
                    : 'ri-subtract-line text-foreground-400'
                }`}></i>
                <span className="text-primary-500 text-sm font-bold">{item.heat}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}